<script>

  import { createBrowserHistory } from 'history'

  export default {
    data () {
      return {
        selectedTab: 'profile',
        tabs: ['profile', 'results', 'publications', 'practice-areas']
      }
    },
    mounted () {
      const history = createBrowserHistory()

      const unlisten = history.listen((location, action) => {
        this.listen(location)
      })

      this.listen(location)

    },
    watch: {
      selectedTab (newTab, oldTab) {
        if (this.tabs.includes(newTab)) {
          location.hash = newTab
        } else {
          this.setDefaultTab()
        }
      }
    },
    methods: {
      isTabSelected(tab) {
        return tab == this.selectedTab
      },
      setTab(tab) {
          this.selectedTab = tab
      },
      setDefaultTab() {
        this.selectedTab = 'profile'
        location.hash = 'profile'
      },
      listen(location) {
        let hash = location.hash.replace('#', '')

        if (hash.length && this.tabs.includes(hash)){
          this.selectedTab = hash
        } else {
          this.setDefaultTab()
        }
      }
    }
  }
</script>
